export const setItem = (key, value) => sessionStorage.setItem(key, value);
export const removeItem = key => sessionStorage.removeItem(key);
export const removeItems = keys => keys.map(key => sessionStorage.removeItem(key));
export const getItem = (key, defaultValue) => {
	const result = sessionStorage.getItem(key);
	return result ? result : defaultValue;
};
